import OnboardingDialogLayout from "@components/layouts/Onboarding/components/OnboardDialogLayout";
import { ForgotSecretPP } from "@components/utils/Auth";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants";
import { OnboardingStepProps } from "@components/utils/OnboardingDialog/types";
import { usePostLoginHandler } from "@hooks/usePostLoginHandler";
import { useTranslation } from "react-i18next";

interface ForgotPinFormProps extends OnboardingStepProps {}

const ForgotSecretStep = ({ navigate, handleClose, layout }: ForgotPinFormProps) => {
  const { t } = useTranslation();
  const { forgotFlowHandlers } = usePostLoginHandler({
    flowMode: "dialog",
  });

  return (
    <OnboardingDialogLayout
      layout={layout}
      pageTitle={t("forgot pin")}
      drawerTitle={t("forgot pin")}
      navigation={{
        close: {
          onClick: handleClose,
        },
        back: {
          onClick: () => navigate(OnboardingDialogStep.Login),
        },
      }}
      features={{
        showCloseButton: true,
        showBackButton: true,
      }}
    >
      <ForgotSecretPP onLoginSuccess={forgotFlowHandlers.handleLoginSuccess} />
    </OnboardingDialogLayout>
  );
};

export default ForgotSecretStep;
